import * as configActions from "../actionTypes/configActionTypes"

export interface ConfigState {
  inAppBackPressed: boolean;
}

const initialState: ConfigState = {
  inAppBackPressed: false,
}

export const ConfigReducer = (
  state: ConfigState = initialState,
  action: configActions.AppBackAction
): ConfigState => {
  switch (action.type) {
    case configActions.IN_APP_BACK_PRESSED:
      return {
        ...state,
        inAppBackPressed: true
      };
    case configActions.RESET_IN_APP_BACK_PRESSED:
      return {
        ...state,
        inAppBackPressed: false
      };
    default:
      return state
  }
}